import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ChartBarIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.81055 6C3.81055 4.34315 5.15369 3 6.81055 3H18.8105C20.4674 3 21.8105 4.34315 21.8105 6V18C21.8105 19.6569 20.4674 21 18.8105 21H6.81055C5.15369 21 3.81055 19.6569 3.81055 18V6ZM6.81055 5C6.25826 5 5.81055 5.44772 5.81055 6V18C5.81055 18.5523 6.25826 19 6.81055 19H18.8105C19.3628 19 19.8105 18.5523 19.8105 18V6C19.8105 5.44772 19.3628 5 18.8105 5H6.81055ZM16.8105 7C17.3628 7 17.8105 7.44772 17.8105 8V16C17.8105 16.5523 17.3628 17 16.8105 17C16.2583 17 15.8105 16.5523 15.8105 16V8C15.8105 7.44772 16.2583 7 16.8105 7ZM12.8105 10C13.3628 10 13.8105 10.4477 13.8105 11V16C13.8105 16.5523 13.3628 17 12.8105 17C12.2583 17 11.8105 16.5523 11.8105 16V11C11.8105 10.4477 12.2583 10 12.8105 10ZM8.81055 13C9.36283 13 9.81055 13.4477 9.81055 14V16C9.81055 16.5523 9.36283 17 8.81055 17C8.25826 17 7.81055 16.5523 7.81055 16V14C7.81055 13.4477 8.25826 13 8.81055 13Z"
            />
        </SvgIcon>
    );
};

export default ChartBarIcon;
